import { render, staticRenderFns } from "./commitDialog.vue?vue&type=template&id=b7abf916&scoped=true"
import script from "./commitDialog.vue?vue&type=script&lang=js"
export * from "./commitDialog.vue?vue&type=script&lang=js"
import style0 from "./commitDialog.vue?vue&type=style&index=0&id=b7abf916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7abf916",
  null
  
)

export default component.exports